<template>
    <div>
        <div v-if="!isEdit" class="my-2">
            <template v-if="caption && caption != ''">
                {{ caption }}
            </template>
            <span v-else class="text-info">
                Inserisci una nota
            </span>
            <a @click="onClickEdit()" class="cursor-pointer">
                <i class="bi bi-pencil"></i>
            </a>
        </div>
        <div v-else>
            <input ref="input" type="text" class="form-control" v-model="caption" v-on:blur="onBlur()" />
        </div>
    </div>
</template>
<script>

import axios from "axios"

export default {
    props: {
        caption: String,
        user_structure_session_content_id: Number
    },
    data() {
        return {
            isEdit: false
        }
    },
    methods: {
        onClickEdit() {
            this.isEdit = true
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },
        onBlur() {
            this.isEdit = false
            axios.post('/structure/session/UserSessionAction-updateCaption', {
                caption: this.caption,
                user_structure_session_content_id: this.user_structure_session_content_id
            })
        }
    }
}

</script>